import React from 'react'

const computeStars = (stars) => {
  if (typeof stars == undefined)
    return {
      width: '2',
      viewBox: '0 0 2 18',
    }

  const width = stars == 0 ? 4 : stars * 4 - 1
  return {
    viewBox: `0 0 ${width} 18`,
    width,
  }
}

const SvgStarIcon = ({ stars, fill = '#FDB022' }) => {
  const svgAttributes = computeStars(stars)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      fill={fill}
      {...svgAttributes}
    >
      <path d="M9.03834 0.609964C9.20914 0.199318 9.79086 0.199318 9.96166 0.609964L12.0278 5.57744C12.0998 5.75056 12.2626 5.86885 12.4495 5.88383L17.8123 6.31376C18.2556 6.3493 18.4354 6.90256 18.0976 7.19189L14.0117 10.6919C13.8693 10.8139 13.8071 11.0053 13.8506 11.1876L15.0989 16.4208C15.2021 16.8534 14.7315 17.1954 14.3519 16.9635L9.76063 14.1592C9.60062 14.0615 9.39938 14.0615 9.23937 14.1592L4.64806 16.9635C4.26851 17.1954 3.79788 16.8534 3.90108 16.4208L5.14939 11.1876C5.19289 11.0053 5.1307 10.8139 4.98831 10.6919L0.902413 7.19189C0.564645 6.90256 0.744408 6.3493 1.18773 6.31376L6.55054 5.88383C6.73744 5.86885 6.90024 5.75056 6.97225 5.57744L9.03834 0.609964Z" />
    </svg>
  )
}

export default SvgStarIcon
